import { render, staticRenderFns } from "./NumberScroll.vue?vue&type=template&id=047a5d67&"
import script from "./NumberScroll.vue?vue&type=script&lang=js&"
export * from "./NumberScroll.vue?vue&type=script&lang=js&"
import style0 from "./NumberScroll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports